import { BeamerBroadcastChannel } from "./BeamerBroadcastChannel";
import { useEffect } from "react";

export function useBeamerBroadcastChannelReceiver(
  setContent: (content: string) => void,
  setFontSizeInViewHeight: (
    value: ((prevState: number) => number) | number,
  ) => void,
) {
  useEffect(() => {
    const channel = new BroadcastChannel(BeamerBroadcastChannel.ChannelName);

    const increaseFontSize = () =>
      setFontSizeInViewHeight((prev) => Math.min(16, prev + 1));
    const decreaseFontSize = () =>
      setFontSizeInViewHeight((prev) => Math.max(2, prev - 1));

    const handler = function (
      this: BroadcastChannel,
      ev: MessageEvent<string>,
    ) {
      if (ev.data === BeamerBroadcastChannel.IncreaseFontSize) {
        increaseFontSize();
      } else if (ev.data === BeamerBroadcastChannel.DecreaseFontSize) {
        decreaseFontSize();
      } else {
        setContent(ev.data);
      }
    };
    channel.addEventListener("message", handler);
    return () => {
      channel.close();
      channel.removeEventListener("message", handler);
    };
  }, [setContent, setFontSizeInViewHeight]);
}
